/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

export enum Language_codeEnum {
  "IT" = "IT",

  "EN" = "EN",

  "FR" = "FR",

  "DE" = "DE",

  "SL" = "SL"
}

// required attributes
const ServiceR = t.interface({});

// optional attributes
const ServiceO = t.partial({
  tags: t.string,

  abi_code: t.string,

  broker_psp_code: t.string,

  cart_card: t.boolean,

  channel_app: t.boolean,

  channel_code: t.string,

  channel_url: t.string,

  convention_code: t.string,

  fixed_cost: t.number,

  flag_io: t.boolean,

  flow_id: t.string,

  language_code: enumType<Language_codeEnum>(
    Language_codeEnum,
    "language_code"
  ),

  logo_psp: t.string,

  logo_service: t.string,

  maximum_amount: t.number,

  minimum_amount: t.number,

  mybank_code: t.string,

  on_us: t.boolean,

  payment_method_channel: t.Integer,

  payment_type_code: t.string,

  psp_business_name: t.string,

  psp_code: t.string,

  psp_flag_stamp: t.boolean,

  service_availability: t.string,

  service_description: t.string,

  service_name: t.string,

  timestamp_insertion: UTCISODateFromString,

  validity_date: UTCISODateFromString
});

export const Service = t.intersection([ServiceR, ServiceO], "Service");

export type Service = t.TypeOf<typeof Service>;
